module.exports = __webpack_public_path__ + "img/1f9e0.9e8c675.svg";